import { render, staticRenderFns } from "./subsale.vue?vue&type=template&id=3b2080ae&scoped=true&"
import script from "./subsale.vue?vue&type=script&lang=js&"
export * from "./subsale.vue?vue&type=script&lang=js&"
import style0 from "./subsale.vue?vue&type=style&index=0&id=3b2080ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2080ae",
  null
  
)

export default component.exports